

<template>
    <section class="sectionBlock">

        <h3 class="h3" @click="$emit('h2click')">

            <div class="h3-inner">
                  <span class="title"><i class="text-ellipsis" v-html="title"></i>

                    <i class="sub-title text-ellipsis" v-if="subTitle">{{subTitle}}</i>

                     <i class="sub-title text-ellipsis" v-else-if="this.$scopedSlots.subTitle">
                         <slot name="subTitle"></slot></i>

                  </span>



                <span class="text-more" v-if="this.$scopedSlots.hMore"><slot name="hMore"></slot></span>
            </div>

            <span class="h3-tips" v-if="tips">{{tips}}</span>

        </h3>


        <slot></slot>


    </section>
</template>

<script>

    export default {
        props: ['title', 'subTitle', 'tips'],

    }

</script>